(function () {
  if (window.__nekonekoDokiProductLoaded) return;
  window.__nekonekoDokiProductLoaded = true;

  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-dd-gallery]');
    if (!gallery) return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-index]'));
    var current = slides.findIndex(function (slide) { return slide.classList.contains('is-active') && !slide.hidden; });
    if (current < 0) current = 0;

    function show(index, scrollThumb) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === current);
        thumb.setAttribute('aria-current', i === current ? 'true' : 'false');
        if (i === current && scrollThumb !== false) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(Number(thumb.dataset.mediaIndex || 0)); });
    });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    function showMedia(mediaId) {
      if (mediaId == null) return;
      var index = slides.findIndex(function (slide) { return slide.dataset.mediaId === String(mediaId); });
      if (index < 0) return;
      show(index, false);
      var thumb = thumbs[index];
      var strip = thumb && thumb.parentElement;
      if (strip) {
        var left = thumb.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft) strip.scrollLeft = left;
        else if (left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + thumb.offsetWidth - strip.clientWidth;
      }
    }
    if (slides[current]) showMedia(slides[current].dataset.mediaId);
    return showMedia;
  }

  function initVariants(root, showVariantMedia) {
    var variants = parseJSON(root.querySelector('[data-variant-json]'), []);
    if (!variants.length) return;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var idInput = root.querySelector('[data-variant-id]');
    var price = root.querySelector('[data-product-price]');
    var button = root.querySelector('[data-add-to-cart]');

    function selectedOptions() {
      return groups.map(function (group) {
        var checked = group.querySelector('[data-option-input]:checked');
        var label = group.querySelector('[data-selected-option]');
        if (label && checked) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }

    function updateVariant() {
      if (!groups.length) return;
      var selected = selectedOptions();
      var variant = variants.find(function (item) {
        return item.options.length === selected.length && item.options.every(function (value, i) { return value === selected[i]; });
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = variant.priceFormatted;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldLabel;
      }
      if (showVariantMedia) showVariantMedia(variant.featuredMediaId);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, Number(input.value || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = Math.max(1, Number(input.value || 1) + 1); });
  }

  function initProduct(root) {
    var showVariantMedia = initGallery(root);
    initVariants(root, showVariantMedia);
    initQuantity(root);
  }

  function initRecommendations() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (container) {
      if (container.dataset.loaded === 'true' || !container.dataset.url) return;
      container.dataset.loaded = 'true';
      fetch(container.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var selector = '[data-product-recommendations][data-section-id="' + container.dataset.sectionId + '"]';
          var fresh = doc.querySelector(selector);
          if (fresh && fresh.innerHTML.trim()) {
            container.innerHTML = fresh.innerHTML;
            var fallback = container.closest('[data-recommendations-section]').querySelector('[data-recommendation-fallback]');
            if (fallback) fallback.hidden = true;
          } else {
            var fallback = container.closest('[data-recommendations-section]').querySelector('[data-recommendation-fallback]');
            if (fallback) fallback.hidden = false;
          }
        })
        .catch(function () {
          var fallback = container.closest('[data-recommendations-section]').querySelector('[data-recommendation-fallback]');
          if (fallback) fallback.hidden = false;
        });
    });
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char];
    });
  }

  function recentCard(item) {
    var image = item.image ? '<img src="' + escapeHTML(item.image) + '" loading="lazy" alt="' + escapeHTML(item.title) + '">' : '';
    return '' +
      '<article class="product-card">' +
        '<a class="product-card__media" href="' + escapeHTML(item.url) + '">' +
          '<span class="wishlist-heart">♡</span>' + image +
        '</a>' +
        '<div class="product-card__body">' +
          '<a class="product-card__title" href="' + escapeHTML(item.url) + '">' + escapeHTML(item.title) + '</a>' +
          '<div class="product-card__bottom"><span class="price">' + escapeHTML(item.price) + '</span><a class="mini-cart-button" href="' + escapeHTML(item.url) + '">View style ♡</a></div>' +
        '</div>' +
      '</article>';
  }

  function initRecentlyViewed() {
    document.querySelectorAll('[data-recent-products]').forEach(function (section) {
      var current = parseJSON(section.querySelector('[data-current-product-json]'), null);
      if (!current || !current.handle) return;
      var key = 'nekonekowig_recent_products_v1';
      var stored = [];
      try { stored = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { stored = []; }
      var previous = stored.filter(function (item) { return item && item.handle && item.handle !== current.handle; });
      var limit = Number(section.dataset.limit || 4);
      var visible = previous.slice(0, limit);
      var grid = section.querySelector('[data-recent-grid]');
      if (grid && visible.length) {
        grid.innerHTML = visible.map(recentCard).join('');
        section.hidden = false;
        var empty = section.querySelector('[data-recent-empty]');
        if (empty) empty.hidden = true;
      } else {
        var empty = section.querySelector('[data-recent-empty]');
        if (empty) empty.hidden = false;
      }
      var next = [current].concat(previous).slice(0, 12);
      try { localStorage.setItem(key, JSON.stringify(next)); } catch (e) {}
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dd-product]').forEach(initProduct);
    initRecommendations();
    initRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
